import { useAuth } from '../auth'
import { useT } from '../i18n'
import { useTheme, type Theme } from '../theme'
import { LangSetting } from './LangSetting'

export function ProfileSettings() {
  const { user, logout } = useAuth()
  const t = useT()
  return (
    <div className="max-w-md space-y-4">
      <div>
        <label className="eyebrow mb-2">Email</label>
        <div className="rounded-lg border border-hull bg-trench px-3 py-2 text-sm text-foam">
          {user?.email || '—'}
        </div>
      </div>
      <ThemeSetting />
      <LangSetting />
      <button
        type="button"
        onClick={logout}
        className="rounded-lg border border-hull px-4 py-2 text-sm text-mist transition-colors hover:border-sonar hover:text-foam"
      >
        {t('settings.profile.logout')}
      </button>
    </div>
  )
}

function ThemeSetting() {
  const t = useT()
  const [theme, toggle] = useTheme()
  const options: Theme[] = ['dark', 'light']
  return (
    <div>
      <label className="eyebrow mb-2">{t('settings.profile.theme')}</label>
      <div className="inline-flex rounded-lg border border-hull bg-trench p-0.5">
        {options.map(o => (
          <button
            key={o}
            type="button"
            aria-pressed={theme === o}
            onClick={() => theme !== o && toggle()}
            className={[
              'rounded-md px-3 py-1.5 text-sm transition-colors',
              theme === o ? 'bg-haze font-medium text-foam' : 'text-mist hover:text-foam',
            ].join(' ')}
          >
            {t(`theme.${o}`)}
          </button>
        ))}
      </div>
    </div>
  )
}
